import { render, staticRenderFns } from "./ViewCandidatesBody.vue?vue&type=template&id=5f73383b&scoped=true"
import script from "./ViewCandidatesBody.vue?vue&type=script&lang=ts"
export * from "./ViewCandidatesBody.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidatesBody.vue?vue&type=style&index=0&id=5f73383b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f73383b",
  null
  
)

export default component.exports